// @flow
import * as React from 'react'
import { AppContext, type AppContextValue } from 'framework'
import { DesktopMediaQuery, MobileMediaQuery } from 'ui/MediaQuery'
import type { LinkManifest } from '../index'
import BasePageHeaderDesktop from './Desktop'
import BasePageHeaderMobile from './Mobile'

type Props = {
  linkManifests: LinkManifest[],
  showNavMenuPrompt: boolean,
  children: React.Node,
}

type State = {
  showNavMenu: boolean,
}

export default class BasePageHeader extends React.Component<Props, State> {
  static defaultProps = {
    showNavMenuPrompt: true,
  }

  static contextType = AppContext
  context: AppContextValue

  state = {
    showNavMenu: false,
  }

  componentWillReceiveProps = (nextProps: Props) => {
    // ensure the nav menu is hidden when the parent component decides to hide the nav menu prmopt
    if (!nextProps.showNavMenuPrompt && this.props.showNavMenuPrompt) {
      this.setState({ showNavMenu: false })
    }
  }

  render = () => {
    const props = {
      user: this.context.user,
      linkManifests: this.props.linkManifests.map(this.hideNavMenuOnClick),
      showNavMenuPrompt: this.props.showNavMenuPrompt,
      showNavMenu: this.state.showNavMenu,
      onToggleNavMenu: this.handleToggleNavMenu,
      children: this.props.children,
    }

    return (
      <React.Fragment>
        <DesktopMediaQuery>
          <BasePageHeaderDesktop {...props} />
        </DesktopMediaQuery>

        <MobileMediaQuery>
          <BasePageHeaderMobile {...props} />
        </MobileMediaQuery>
      </React.Fragment>
    )
  }

  handleToggleNavMenu = () => {
    this.toggleNavMenu()
  }

  toggleNavMenu = () => {
    this.setState(prevState => ({ showNavMenu: !prevState.showNavMenu }))
  }

  hideNavMenuOnClick = (linkManifest: LinkManifest) => {
    const onClick = () => {
      this.setState({ showNavMenu: false })

      if (linkManifest.onClick) linkManifest.onClick()
    }

    return { ...linkManifest, onClick }
  }
}
